import React, { Fragment } from 'react';
import { Container } from 'reactstrap';

const Video = () => {
  return (
    <Fragment>
      <Container className="iframe-container">
        <iframe
          src="https://www.youtube.com/embed/eZw4Ga3jg3E"
          className="video-embed"
          width="560"
          height="315"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          title="Fight Germs. Wash Your Hands!"
          allowFullScreen={true}>
        </iframe>
      </Container>
      <p className="text-muted small text-center mt-1">
        Public health education resource. Not clinical advice.
      </p>
    </Fragment>
  )
}

export default Video;
